import { i18n } from 'localization'
import { parseDate, parsePerson } from './utils'

export default class FinalSituation {
	static fromJSON(json) {
		return new FinalSituation(json.id, json.type)
			.withBody(json.justification)
			.withDate(json.createdAt)
			.withDoctor(json.doctor)
			.withEntity(json.doctor)
			.withExpectedSituation(json.expectedSituation, json.disability?.id)
			.withDisability(json.disability)
	}

	constructor(id, type) {
		this.id = id
		this.type = type
		this.textId = `final_situation_${id || ''}`
		this.key = this.textId
	}
	withBody(body) {
		this.body = body?.replace(/<br\/>/gi, '\r\n').trim()
		this.text = body
		this.justification = body
		return this
	}
	withDisability(json) {
		this.disability = json
			? {
					id: json.id,
					value: json.id,
					name: i18n.translate(json.name),
					text: i18n.translate(json.name),
			  }
			: null
		return this
	}
	withExpectedSituation(json, disabilityID) {
		this.expectedSituation =
			json && disabilityID === 'ACCD'
				? {
						biologicalDamage: json.biologicalDamage
							? Math.round(json.biologicalDamage * 100) / 100
							: undefined,
						permanentPartialDisabilityRateFinal: json.permanentPartialDisabilityRateFinal
							? Math.round(
									json.permanentPartialDisabilityRateFinal *
										100 *
										100
							  ) / 100
							: undefined,
						permanentPartialDisabilityRate:
							Math.round(
								json.permanentPartialDisabilityRate * 100 * 100
							) / 100,
						weight: json.weight,
						// used within wizard
						weightOption: json.weight
							? {
									value: json.weight,
									text: `${json.weight.toFixed(1)}`,
							  }
							: undefined,
						treatmentDays: json.treatmentDays,
						temporaryTotalDisabilityDays:
							json.temporaryTotalDisabilityDays,
						additionalEfforts: !!json.additionalEfforts,
						isPermanentTotalDisabilityForOrdinaryWork: !!json.isPermanentTotalDisabilityForOrdinaryWork,
				  }
				: {
						treatmentDays: json?.treatmentDays,
						temporaryTotalDisabilityDays:
							json?.temporaryTotalDisabilityDays,
						additionalEfforts: !!json?.additionalEfforts,
						isPermanentTotalDisabilityForOrdinaryWork: !!json?.isPermanentTotalDisabilityForOrdinaryWork,
				  }
		return this
	}
	withDate(dateStr) {
		if (dateStr) {
			this.date = parseDate(dateStr)
		} else {
			this.date = {}
		}
		return this
	}
	withDoctor(json) {
		this.doctor = json ? parsePerson(json) : null
		return this
	}
	withEntity(json) {
		this.entity = json?.entity?.name || ''
		return this
	}
}
